import {useLocation, useMatches} from '@remix-run/react'
import * as Sentry from '@sentry/remix'
import {useEffect} from 'react'

export function initSentryClient() {
  Sentry.init({
    dsn: window.ENV.SENTRY_DNS,
    environment: window.ENV.MODE,
    release: `mmt-web@${window.ENV.VERSION}`,
    tracesSampleRate: 0,
    replaysSessionSampleRate: window.ENV.SENTRY_REPLAY_SAMPLE_RATE,
    replaysOnErrorSampleRate: window.ENV.SENTRY_REPLAY_ERROR_SAMPLE_RATE,

    integrations: [
      Sentry.browserTracingIntegration({
        useEffect,
        useLocation,
        useMatches,
      }),
      Sentry.replayIntegration(),
    ],
  })
}
